import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-catalyst-core/src/components/layout.js";
import Player from '/src/components/Player';
import FileLister from '/src/components/FileLister';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Seo = makeShortcode("Seo");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Seo title="Library" mdxType="Seo" />
    <h1 {...{
      "id": "library"
    }}>{`Library`}</h1>
    <p>{`Welcome to our library of content curated just for this node at Abolition Plaza. `}</p>
    <h2 {...{
      "id": "reading"
    }}>{`Reading`}</h2>
    <p>{`A section for reading in Abolition Plaza.`}</p>
    <FileLister mdxType="FileLister" />
    <h2 {...{
      "id": "sounds"
    }}>{`Sounds`}</h2>
    <Player audiofile='dulce_owen_ac.ogg' title="Dulce Et Decorum Est" mdxType="Player" />
    <Player audiofile='green.mp3' title="Green" mdxType="Player" />
    <Player audiofile='army.m4a' title="Army of Me" mdxType="Player" />
    <Player audiofile='https://ia800703.us.archive.org/32/items/AngelaDavisOccupyPhiladelphia/AngelaDavisOccupyPhiladelphia_tagliato.ogg
' title="Angela Davis at Occupy Philadelphia" mdxType="Player" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      